import credentialTypes from "../constants/credentialTypes";

/**
 * Traduz os tipos de credenciais que aparecem nos logs
 * @param {string} logText - Texto do log que pode conter tipos de credenciais
 * @param {object} intl - Objeto intl do react-intl para tradução
 * @returns {string} - Texto do log com os tipos de credenciais traduzidos
 */
export const translateLogCredentials = (logText, intl) => {
  if (!logText || typeof logText !== 'string') {
    return logText;
  }

  let translatedText = logText;

  // Usa o mesmo mapeamento de credentialTypes para garantir consistência
  const credentialTypesArray = credentialTypes();
  
  // Substitui cada tipo de credencial pela sua tradução
  credentialTypesArray.forEach(({ value, label }) => {
    const regex = new RegExp(value, 'g');
    translatedText = translatedText.replace(regex, label);
  });

  return translatedText;
};
